<template>
  <div>
    <v-form :ref="formName">
      <v-row
        v-for="(content, index) in contents"
        no-gutters
        :key="`mentorContent${index}`"
        :class="isMarginBottomNeeded(index, content.fieldType) ? 'mb-4' : ''"
      >
        <v-col
          v-if="language"
          cols="12"
          class="black--text font-weight-medium"
          :class="content.fieldType === 'textBold' ? 'font-weight-bold' : ''"
        >
          {{
            content.labelLocales.find((ll) => ll.language == language)
              ? content.labelLocales.find((ll) => ll.language == language).value
              : content.labelLocale.value
          }}</v-col
        >
        <v-col
          v-else
          cols="12"
          class="black--text font-weight-medium"
          :class="content.fieldType === 'textBold' ? 'font-weight-bold' : ''"
        >
          {{ content.labelLocale.value }}</v-col
        >

        <v-input
          v-if="content.fieldType === 'rating'"
          :value="content.value.rating"
          :rules="[rules.required]"
          hide-details="auto"
        >
          <span class="d-none d-print-block"
            >{{ content.value.rating }}/5
          </span>
          <v-rating v-model="content.value.rating" :readonly="disabled" />
        </v-input>

        <v-textarea
          v-else-if="content.fieldType === 'textarea' && !disabled"
          v-model="content.value.text"
          rows="1"
          auto-grow
          :rules="[rules.required]"
          :disabled="disabled"
        />

        <div
          v-else-if="content.fieldType === 'textarea' && disabled"
          :style="{
            borderBottom: '1px solid #ccc',
            padding: content.value.text ? '4px' : '10px',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            width: '100%',
            boxSizing: 'border-box',
          }"
        >
          {{ content.value.text }}
        </div>

        <v-input
          v-else-if="content.fieldType === 'checkbox'"
          :value="content.value.boolean"
          :rules="[rules.required]"
          hide-details="auto"
        >
          <feedback-checkbox
            :value.sync="content.value.boolean"
            :disabled="disabled"
          />
        </v-input>
      </v-row>
    </v-form>
    <v-row no-gutters v-if="!disabled">
      <v-spacer />
      <v-btn color="primary" class="ma-2" @click="submit">
        {{ $t("dialog.submit") }}
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import FeedbackCheckbox from "@/components/mentorship/control/feedback/Checkbox.vue";

export default {
  props: {
    formName: {
      type: String,
      required: true,
    },
    formContents: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    language: {
      type: String,
      default: null,
    },
  },

  components: {
    FeedbackCheckbox,
  },

  data() {
    return {
      rules: {
        required: (value) =>
          (value !== "" && value !== null && value !== undefined) ||
          this.$t("validation.required"),
      },
    };
  },

  computed: {
    contents() {
      return this.formContents;
    },
  },

  methods: {
    isMarginBottomNeeded(index, fieldType) {
      if (index == this.contents.length - 1) {
        return false;
      }

      if (["text", "textBold"].includes(fieldType)) {
        return false;
      }

      return this.contents[index + 1].fieldType != fieldType;
    },
    hide() {
      this.$emit("hide");
    },
    submit() {
      if (!this.$refs[this.formName].validate()) {
        return;
      }

      this.$emit("submit", this.contents);
    },
  },
};
</script>
